<div class="page-title mb-3">
    <h3>Tenants</h3>
</div>
<div id="tenant-list" class="grid-container">
    <router-outlet></router-outlet>
    <ag-grid-angular class="ag-theme-bootstrap grid" 
                    pagination 
                    paginationPageSize="10"
                    [gridOptions]="gridOptions"
                    (gridSizeChanged)="onGridSizeChanged($event)" 
                    (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</div>
<div class="d-flex flex-row mb-5">
    <div class="col-12 d-flex justify-content-end p-0">
        <button type="button" class="btn btn-secondary" (click)='refresh()'>Refresh</button>
        <button type="button" id="createTenantId" class="btn btn-primary ml-auto" (click)='openCreateModal()'>Create Tenant</button>
    </div>
</div>
